__turbopack_context__.v({
  "dealerInfo": "CallDealerCTA-module__Ko_Dbq__dealerInfo",
  "error": "CallDealerCTA-module__Ko_Dbq__error",
  "modalContainer": "CallDealerCTA-module__Ko_Dbq__modalContainer",
  "topPriority": "CallDealerCTA-module__Ko_Dbq__topPriority",
});
